"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _LinkContent = _interopRequireDefault(require("./LinkContent"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var CardNavigationItem = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CardNavigationItem, _React$Component);

  var _super = _createSuper(CardNavigationItem);

  function CardNavigationItem() {
    (0, _classCallCheck2["default"])(this, CardNavigationItem);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(CardNavigationItem, [{
    key: "getColumnStyle",
    value: function getColumnStyle(type, value) {
      var _this$props = this.props,
          height = _this$props.height,
          rounded = _this$props.rounded;
      var baseStyle = {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '1em',
        borderRadius: "".concat(rounded ? '8px' : '0')
      };
      return type === 'image' ? _objectSpread({}, baseStyle, {
        backgroundImage: "url('".concat(value, "')")
      }) : _objectSpread({}, baseStyle, {
        backgroundColor: value
      });
    }
  }, {
    key: "renderImageColumn",
    value: function renderImageColumn() {
      var _this$props2 = this.props,
          internal = _this$props2.internal,
          slug = _this$props2.slug,
          as = _this$props2.as,
          gatsbyLink = _this$props2.gatsbyLink,
          background = _this$props2.background,
          type = _this$props2.type,
          gutter = _this$props2.gutter,
          height = _this$props2.height;
      var columnStyle = this.getColumnStyle(type, background);
      var bodyStyle = gutter ? columnStyle : {
        textAlign: 'center',
        verticalAlign: 'middle',
        display: 'flex',
        alignItems: 'center',
        height: height,
        width: '100%'
      };

      var body = /*#__PURE__*/_react["default"].createElement("div", {
        style: bodyStyle
      });

      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        key: slug,
        style: !gutter ? columnStyle : {}
      }, /*#__PURE__*/_react["default"].createElement(_LinkContent["default"], {
        internal: internal,
        slug: slug,
        body: body,
        as: as,
        gatsbyLink: gatsbyLink
      }));
    }
  }, {
    key: "renderLabelColumn",
    value: function renderLabelColumn() {
      var _this$props3 = this.props,
          internal = _this$props3.internal,
          slug = _this$props3.slug,
          as = _this$props3.as,
          gatsbyLink = _this$props3.gatsbyLink,
          background = _this$props3.background,
          content = _this$props3.content,
          type = _this$props3.type,
          gutter = _this$props3.gutter,
          height = _this$props3.height;
      var columnStyle = this.getColumnStyle(type, background);
      var bodyStyle = gutter ? columnStyle : {
        textAlign: 'center',
        verticalAlign: 'middle',
        display: 'flex',
        alignItems: 'center',
        height: height,
        width: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        key: slug,
        style: !gutter ? columnStyle : {}
      }, /*#__PURE__*/_react["default"].createElement(_LinkContent["default"], {
        internal: internal,
        slug: slug,
        body: content,
        as: as,
        gatsbyLink: gatsbyLink,
        style: bodyStyle
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var type = this.props.type;
      return type === 'image' ? this.renderImageColumn() : this.renderLabelColumn();
    }
  }]);
  return CardNavigationItem;
}(_react["default"].Component);

exports["default"] = CardNavigationItem;